import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {ModalWindowComponent} from "../../std-components/modal-window/modal-window.component";
import {ServerService} from "../../shared/services/server.service";
import {EventService} from "../../shared/services/event.service";
import {IObject1} from "../../shared/models/models";
import {ToastrService} from 'ngx-toastr';
import {ImageService} from "../../shared/services/image.service";
import {CommonModule} from "@angular/common";
import {NumberWithSpacesPipe} from "../../shared/pipes/number-with-spaces.pipe";
import {FormsModule} from "@angular/forms";
import {PdfViewerModule} from "ng2-pdf-viewer";
import {CalendarComponent} from "../calendar/calendar.component";
import {TypeofotComponent} from "../typeofot/typeofot.component";
import { NgxMaskDirective, provideNgxMask } from "ngx-mask";


export interface OneFlatSales {
  set1: OneFlatSalesSet1;
  set2: OneFlatSalesSet2[];
  set3: OneFlatSalesSet3;
}

export interface OneFlatSalesSet1 {
  ID?: number;
  columnID?: number;
  flatArea?: number;
  flatConfigurationID?: number;
  flatNumber?: string;
  photoFileID?: number;
  priceAmount?: number;
  saleAmount?: number;
  saleDate?: string;
  furnishItemsList?: string;
  isCornerFlat?: number;
  fileTypeId?: number;
  file?: any;
  fileExtension?: string;
  // новые поля
  entrance?: string;
  usableArea?: number;
  balconyArea?: number;

  // для других помещений
  buildingID?: number;
  roomTypeItemID?: number;
  placeCount?: number;
  area?: number;
  delete?: boolean;
}

export interface OneFlatSalesSet2 {
  furnishItemID: number;
  furnishItemTitle: string;
}

export interface OneFlatSalesSet3 {
  flatPlanAmount: number;
}

@Component({
  selector: "app-flats-modal",
  templateUrl: "./flats-modal.component.html",
  styleUrls: ["./flats-modal.component.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, PdfViewerModule,
    NumberWithSpacesPipe, ModalWindowComponent, CalendarComponent, TypeofotComponent,
    NgxMaskDirective,
  ],
  providers: [
    provideNgxMask()
  ]
})
export class FlatsModalComponent implements OnInit {
  @Input() flat;
  @Input() flatId: number;
  @Input() buildingId: number;
  @Input() otherRoomFlag: boolean;
  @Input() flat_modal_info: boolean = true;
  @Input() furnishTemplate: OneFlatSalesSet2[] = [];
  @Output() confirmEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() confirmEventTwo = new EventEmitter();
  @Input() spotForm: string;

  oneFlatData: OneFlatSales;
  oneFlatDataSet1: OneFlatSalesSet1;
  oneFlatDataSet2: OneFlatSalesSet2[] = [];
  oneFlatDataSet3: OneFlatSalesSet3;
  imageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
  imgHover: boolean = false;

  loading: boolean = false;
  calendarModal: boolean = false;
  placeType: string = "";

  object: IObject1 = null;
  startCalendarModal = false;
  fileToUpload: File = null;
  furnishModal: boolean = false;
  confirmLoader: boolean = false;
  reader: any;

  priceFlatPerSquare: number = 0;
  viewFurnishType: boolean = false;
  flatRealizationDateInfo = {};
  editedDate: number = null;

  loadPlan: boolean;

  saleAmount: boolean = false;

  constructor(
    private modalWindow: ModalWindowComponent,
    private server: ServerService,
    private eventService: EventService,
    public toastr: ToastrService,
    private imgService: ImageService,
  ) {
    // this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit() {
    if (!this.otherRoomFlag) {
      if (this.flatId > 0) {
        this.loadData();
      } else {
        this.oneFlatDataSet1 = {
          columnID: this.flat.columnID,
          flatArea: null,
          flatConfigurationID: this.flat.flatConfigurationID,
          flatNumber: "",
          priceAmount: 0,
          saleAmount: 0,
          saleDate: null,
          furnishItemsList: "-1",
          isCornerFlat: null,
          entrance: '',
          balconyArea: null,
          usableArea: null,
        };
      }
    } else {
      this.oneFlatDataSet1 = {
        roomTypeItemID: this.flat.id,
        area: this.flat.info.area,
        placeCount: this.flat.info.placeCount,
        buildingID: this.buildingId,
        photoFileID: this.flat.info.photoFileID
      };
      this.getPhoto(this.oneFlatDataSet1.photoFileID);
      this.getPhoto(this.oneFlatDataSet1.photoFileID);
      this.getPlaceType(this.oneFlatDataSet1.roomTypeItemID);
    }
  }

  getReturnFurnishes(event) {
    this.oneFlatDataSet2 = event;
    this.oneFlatDataSet1.furnishItemsList = this.updateFurnishList(
      this.oneFlatDataSet2
    ).join(",");
  }

  loadData() {
    this.loading = true;
    this.server.getRealizationOneFlatSalesInfo(this.flatId).then(res => {
      this.loading = false;
      this.oneFlatData = res;
      this.oneFlatDataSet1 = res.set1;
      this.oneFlatDataSet2 = res.set2;
      this.oneFlatDataSet3 = res.set3;
      this.viewFurnishType = res.set2.length > 0 && res.set2[0].furnishItemID !== -1;
      this.oneFlatDataSet1.furnishItemsList = this.updateFurnishList(
        this.oneFlatDataSet2
      ).join(",");
      this.editedDate = new Date(res.set1.saleDate).getTime();
      this.flatRealizationDateInfo[this.editedDate] = res.set1.saleAmount;
      this.getPhoto(this.oneFlatDataSet1.photoFileID);
      this.getPhoto(this.oneFlatDataSet1.photoFileID);
      this.countPricePerSquare();
      this.loadPlan = this.oneFlatDataSet1.photoFileID !== null;
    });
  }

  updateFurnishList(rows: OneFlatSalesSet2[]) {
    let res: number[] = [];
    rows.map(r => {
      res.push(r.furnishItemID);
    });
    return res;
  }

  changeFurnishType(type: boolean) {
    if (type) {
      this.oneFlatDataSet1.furnishItemsList = this.updateFurnishList(
        this.oneFlatDataSet2
      ).join(",");
    } else {
      this.oneFlatDataSet1.furnishItemsList = "-1";
    }
    this.viewFurnishType = type;
  }

  getPlaceType(roomTypeItemID) {
    if (roomTypeItemID === -1) {
      return (this.placeType = "комнат");
    }
    if (roomTypeItemID === 202) {
      return (this.placeType = "помещений");
    }
    return (this.placeType = "мест");
  }

  getDate(timestamp) {
    if (timestamp !== null) {
      let date = new Date(timestamp);
      return (
        date.getDate() +
        " " +
        this.getMonthName(date) +
        " " +
        date.getFullYear() +
        "г."
      );
    }
    return "-";
  }

  getMonthName(date: Date) {
    return this.eventService.getMonthName(date.getMonth() + 1, true, true);
  }

  getTimestamp(date: string) {
    let dateEx = new Date(date);
    let day: number = dateEx.getDate();
    let month: number = dateEx.getMonth();
    let year: number = dateEx.getFullYear();
    return new Date(year, month, day).getTime();
  }

  getNatNum(changedValue) {
    if (changedValue === "flatArea") {
      if (!this.countPricePerSquare()) {
        this.countPriceAmount();
      }
    } else if (changedValue === "priceAmount") {
      if (!this.countPricePerSquare()) {
        this.countFlatArea();
      }
    } else if (changedValue === "priceFlatPerSquare") {
      if (!this.countPriceAmount()) {
        this.countFlatArea();
      }
    }
  }

  countFlatArea(): boolean {
    if (
      this.oneFlatDataSet1.priceAmount !== null &&
      this.priceFlatPerSquare !== null &&
      this.priceFlatPerSquare !== 0
    ) {
      this.oneFlatDataSet1.flatArea =
        this.oneFlatDataSet1.priceAmount / this.priceFlatPerSquare;
      return true;
    }
    return false;
  }

  countPriceAmount(): boolean {
    if (
      this.oneFlatDataSet1.flatArea !== null &&
      this.priceFlatPerSquare !== null
    ) {
      this.oneFlatDataSet1.priceAmount =
        this.oneFlatDataSet1.flatArea * this.priceFlatPerSquare;
      return true;
    }
    return false;
  }

  countPricePerSquare(): boolean {
    if (
      this.oneFlatDataSet1.priceAmount !== null &&
      this.oneFlatDataSet1.flatArea !== null &&
      this.oneFlatDataSet1.flatArea !== 0
    ) {
      this.priceFlatPerSquare = parseInt(
        (
          this.oneFlatDataSet1.priceAmount / this.oneFlatDataSet1.flatArea
        ).toFixed(2)
      );
      return true;
    }
    return false;
  }

  confirm() {
    this.confirmLoader = true;
    if (!this.otherRoomFlag) {
      this.oneFlatDataSet1.ID = this.flatId;
      // if (this.flatId === -1) {
      //   this.server
      //     .insertRealizationOneFlatSalesInfo(this.oneFlatDataSet1)
      //     .then(
      //       res => {
      //         if (res) {
      //           this.toastr.success("Изменения сохранены!", "Успешно!", {
      //             timeOut: 5000
      //           });
      //           this.eventService.confirmForFlats.emit(true);
      //           this.oneFlatDataSet1.ID = res;
      //           this.confirmEvent.emit(true);
      //           this.confirmEventTwo.emit(this.oneFlatDataSet1);
      //           this.confirmLoader = false;
      //           this.cancelModal();
      //         }
      //       },
      //       (err: any) => {
      //         if (err.status == 500 || err.status == 0) {
      //           this.toastr.error(
      //             "К сожалению, сервер временно недоступен. Попробуйте повторить действие чуть позже!",
      //             "Ваши данные не сохранены!",
      //             {
      //               timeOut: 5000
      //             }
      //           );
      //         }
      //       }
      //     );
      // } else {
      this.server
        .updateRealizationOneFlatSalesInfo(this.oneFlatDataSet1)
        .then(
          res => {
            if (res) {
              this.toastr.success("Изменения сохранены!", "Успешно!", {
                timeOut: 5000
              });
              this.eventService.confirmForFlats.emit(true);
              this.confirmEvent.emit(true);
              this.confirmEventTwo.emit(this.oneFlatDataSet1);
              this.cancelModal();

              // window.location.reload();
              this.confirmLoader = false;
            }
          },
          (err: any) => {
            if (err.status == 500 || err.status == 0) {
              this.toastr.error(
                "К сожалению, сервер временно недоступен. Попробуйте повторить действие чуть позже!",
                "Ваши данные не сохранены!",
                {
                  timeOut: 5000
                }
              );
            }
          }
        );
      // }
    } else {
      // let obj: BuildingOtherRooms = { BuildingID: null, RoomTypeItemID: null, Delete: false, Area: 0, PlaceCount: 0, PhotoFileID : 0 };
      // obj.BuildingID = this.buildingId;
      // obj.Area = this.oneFlatDataSet1.area;
      // obj.RoomTypeItemID = this.oneFlatDataSet1.roomTypeItemID;
      // obj.PlaceCount = this.oneFlatDataSet1.placeCount;
      // obj.PhotoFileID = this.oneFlatDataSet1.photoFileID;
      // obj.file = this.oneFlatDataSet1.file;
      this.server.setBuildingOtherRooms(this.oneFlatDataSet1).then(
        res => {
          if (res) {
            this.toastr.success("Изменения сохранены!", "Успешно!", {
              timeOut: 5000
            });
            this.eventService.confirmForFlats.emit(true);
            this.confirmEvent.emit(true);
            this.confirmEventTwo.emit(this.oneFlatDataSet1);
            this.confirmLoader = false;
            this.cancelModal();
          }
        },
        (err: any) => {
          if (err.status == 500 || err.status == 0) {
            this.toastr.error(
              "К сожалению, сервер временно недоступен. Попробуйте повторить действие чуть позже!",
              "Ваши данные не сохранены!",
              {
                timeOut: 5000
              }
            );
          }
        }
      );
    }
  }

  cancelModal() {
    this.modalWindow.closeModalWindow();
  }

  pdfSrc = "data:application/pdf;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
  page = 1;

  handleFileInput(event: Event) {
    const file = (event.target as HTMLInputElement).files;
    this.oneFlatDataSet1.fileTypeId = 1;
    this.oneFlatDataSet1.file = file.item(0);
    this.reader = new FileReader();
    if (file[0].type === "image/png" || file[0].type === "image/jpeg") {
      this.oneFlatDataSet1.fileExtension = "";
      this.reader.onload = (event: any) => {
        this.imageUrl = event.target.result;
        this.imgHover = true;
      };
      this.loadPlan = true;
      this.reader.readAsDataURL(this.oneFlatDataSet1.file);
    }
    if (file[0].type === "application/pdf") {
      this.oneFlatDataSet1.fileExtension = "pdf";
      this.reader.onload = (event: any) => {
        this.pdfSrc = event.target.result;
        this.imgHover = true;
      };
      this.loadPlan = true;
      this.reader.readAsDataURL(this.oneFlatDataSet1.file);
      this.oneFlatDataSet1.fileTypeId = 3;
    }
  }

  getPhoto(fileId: number) {
    if (fileId) {
      this.imgHover = true;
      this.imgService.getImage(fileId, false, 'Files/DownloadBuildingFile?fileId=').subscribe(
        (base64Image) => {
          this.imageUrl = base64Image;
          this.pdfSrc = base64Image;
        },
        (error) => {
          console.error('Error loading image:', error);
          this.imageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
          this.pdfSrc = this.imageUrl; // Set fallback image for both imageUrl and pdfSrc
        }
      );
    } else {
      this.imgHover = false;
      this.imageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
      this.pdfSrc = this.imageUrl;
    }
  }


  zoommedPhoto: boolean = false;

  zoomPhoto() {
    this.zoommedPhoto = true;
  }

  deleteFurnishType(type: OneFlatSalesSet2) {
    this.oneFlatDataSet2 = this.oneFlatDataSet2.filter(
      f => f.furnishItemID !== type.furnishItemID
    );
    this.oneFlatDataSet1.furnishItemsList = this.updateFurnishList(
      this.oneFlatDataSet2
    ).join(",");
  }

  completeFlatDateRealization(event) {
    if (this.isNull(event)) {
      for (let key in event) {
        this.oneFlatDataSet1.saleDate = new Date().toString();
        this.oneFlatDataSet1.saleAmount = event[key];
      }
      this.editedDate = new Date(this.oneFlatDataSet1.saleDate).getTime();
      this.flatRealizationDateInfo[this.editedDate] = this.oneFlatDataSet1.saleAmount;
    } else if (this.isEmpty(event)) {
      this.oneFlatDataSet1.saleDate = null;
      this.oneFlatDataSet1.saleAmount = null;
      this.editedDate = null;
      this.flatRealizationDateInfo = {};
    } else {
      for (let key in event) {
        this.oneFlatDataSet1.saleDate = new Date(parseInt(key)).toString();
        this.oneFlatDataSet1.saleAmount = event[key];
      }
      this.editedDate = new Date(this.oneFlatDataSet1.saleDate).getTime();
      this.flatRealizationDateInfo[this.editedDate] = this.oneFlatDataSet1.saleAmount;
    }
  }

  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  isNull(obj) {
    for (var key in obj) {
      if (key == '0') return true;
    }
    return false;
  }

  selectTemplate() {
    this.oneFlatDataSet2 = [];
    this.oneFlatDataSet2 = this.furnishTemplate;
    this.oneFlatDataSet1.furnishItemsList = this.updateFurnishList(
      this.oneFlatDataSet2
    ).join(",");
  }

  deletePlan(fileID) {
    this.oneFlatDataSet1.photoFileID = null;
    this.server.removePlan(fileID).then(
      _ => {
        this.toastr.success("Изменения сохранены!", "Успешно!");
        this.loadPlan = false;
      },
      (err: any) => {
        if (err.status == 500 || err.status == 0) {
          this.toastr.error(
            "К сожалению, сервер временно недоступен. Попробуйте повторить действие чуть позже!",
            "Ваши данные не сохранены!"
          );
        }
      }
    );
  }

  openEditor() {
    this.saleAmount = this.saleAmount === false;
  }
}
